import { Button, Divider, Input, Spin } from "antd";
import { useEffect, useState } from "react";
import arrowLeft from "./../../assets/images/arrow-left.svg";
import user from "./../../assets/images/user.svg";
import { useNavigate } from "react-router-dom";
import { register } from "./service";
import useStore from "../../store/useStore";
import {
  getDecodedToken,
  getLocalStorage,
  setLocalStorage,
} from "../../utils/localStorage";
import { AUTH_TOKEN } from "../../utils/constants";

const PersonalDetails = () => {
  const navigate = useNavigate();
  const { doctorDetails, setDoctorDetails } = useStore((state) => ({
    doctorDetails: state.doctorDetails,
    setDoctorDetails: state.setDoctorDetails,
  }));

  const [firstName, setFirstName] = useState(
    getLocalStorage("firstName") || ""
  );
  const [lastName, setLastName] = useState(getLocalStorage("lastName") || "");
  const [isContinueDisabled, setIsContinueDisabled] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!doctorDetails?.mobileNumber) {
      navigate("/on-boarding");
    }
  }, []);

  useEffect(() => {
    if (firstName?.trim()?.length && lastName?.trim()?.length) {
      setIsContinueDisabled(false);
    } else {
      setIsContinueDisabled(true);
    }
  }, [firstName, lastName]);

  const firstNameHandler = (e: any) => {
    setFirstName(e.target.value?.replace(" ", ""));
  };

  const lastNameHandler = (e: any) => {
    setLastName(e.target.value);
  };

  const continueBtnHandler = async () => {
    setLoading(true);
    try {
      setLocalStorage("firstName", firstName?.trim());
      setLocalStorage("lastName", lastName?.trim());
      setTimeout(() => {
        navigate("/speciality");
      }, 100);
    } catch (error) {
      console.error("Error saving personal details:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col justify-between h-full">
      <div className="flex flex-col items-start p-6">
        <div className="text-left text-lg xs:text-xl xsPlus:text-2xl font-semibold pb-4 pt-4">
          Please enter your full name
        </div>
        <label className="text-sm pb-1 flex">
          First Name<span className="text-[#E54848]">*</span>
        </label>
        <Input
          placeholder="Enter your first name"
          prefix={
            <>
              <img src={user} alt="user" className="p-2" />
              {" Dr. "}
            </>
          }
          onChange={firstNameHandler}
          value={firstName}
          name="firstName"
          autoFocus={true}
          maxLength={20}
          autoCorrect="off"
          spellCheck={false}
          autoComplete="off"
        />
        <label className="text-sm py-1 pt-7 flex">
          Last Name<span className="text-[#E54848]">*</span>
        </label>
        <Input
          placeholder="Enter your last name"
          className="p-[11px]"
          onChange={lastNameHandler}
          value={lastName}
          name="lastName"
          maxLength={30}
          autoCorrect="off"
          spellCheck={false}
          autoComplete="off"
        />
      </div>
      <div className="w-full absolute bottom-6 left-0">
        <div className="flex flex-col items-center max-w-[1280px] w-full">
          <Divider />
          <Button
            type="primary"
            className="w-[85%] h-14 rounded-2xl bg-[#4B4AD5] p-5 text-lg font-medium"
            onClick={continueBtnHandler}
            disabled={isContinueDisabled}
            loading={loading}
          >
            Continue
          </Button>
        </div>
      </div>
      {loading && <Spin />}
    </div>
  );
};

export default PersonalDetails;
